import React, {  PureComponent } from 'react';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { connect } from 'react-redux';
import * as messageActions from '../modules/message'
import * as uiActions from '../modules/ui';
import * as arkActions from '../modules/ark'
import * as settingAction from '../modules/setting'
import * as feedbackAction from '../modules/feedback'
import * as realtimeAction from '../modules/realtimeAnswer'
import * as configAction from '../modules/config'
import * as ssocheckAction from '../modules/ssoCheck'
import { setGpt, getGpt } from '../modules/settingAction'

import '../css/chatbot.css'
import { ChatTop, ChatBottom, ChatMessageList} from '../Components';
import { SettingLayer, SideMenuLayer, AlertLayer, LoginAlertLayer, OverLayLayer, FeedbackLayer, AgreeContentLayer, AlertFavorites, UseTip} from '../Components/Layer'
import { LANG_CN, LANG_KO, LANG_EN, LANG_JA, LANG_VI} from '../utils/lang'
import { setCookie, getCookie } from '../utils/utils';
import { redirectSso } from '../utils/utils';

const urlPropsQueryConfig = {
    isDev: { type: UrlQueryParamTypes.boolean, queryParam: 'isDev' },
    from: { type: UrlQueryParamTypes.String, queryParam: 'from' },
    projectId: { type: UrlQueryParamTypes.String, queryParam: 'projectId' },
    lang: { type: UrlQueryParamTypes.String, queryParam: 'lang' },
}
class App extends PureComponent {
    constructor(props) {
        super(props);

        let isIframe = false;
        // iframe시 parent에게 보내줄 초기 Data
        if ((window && window.parent) && (window !== window.parent)) {
            const LAYER_LOAD_INIT = {
                "enabled": true,
                "publicInfo": {
                    "icon": "https://chat.cau.ac.kr/v2/img/sitelink_img.png",
                    "title": "eadvisor-chatbot",
                    "iconSize": "68px",
                    "themeColor": "#2f6e8d",
                    "description": "[]",
                    "iconPosition": "right",
                    "popupMessage": "<HTML> <body> <p style=\"color:#2F6E8D;\"><b>\n도움이 필요하신가요?</b></body> </HTML>",
                    "showPopupMessage": false,
                    "buttonBorderRadius": "50%"
                }
            }
            window.parent.postMessage(LAYER_LOAD_INIT, '*');
            isIframe = true;
        }
        // config 세팅
        if (this.props.projectId !== undefined && this.props.projectId !== null && this.props.projectId !== "") {
            this.props.configEvents.setProject(this.props.projectId)
        }
        if (this.props.from !== undefined && this.props.from !== null && this.props.from !== "") {
            this.props.configEvents.setFrom(this.props.from)
        }
        if (this.props.lang !== undefined && this.props.lang !== null && this.props.lang !== "") {
            this.props.configEvents.setLang(this.props.lang)
            let textData = LANG_KO
            if (this.props.lang === "en") textData = LANG_EN
            if (this.props.lang === "cn") textData = LANG_CN
            if (this.props.lang === "ja") textData = LANG_JA
            if (this.props.lang === "vi") textData = LANG_VI
            
            this.props.uiEvents.Layout.setTexts(textData)
        }
        if (this.props.isDev !== undefined && this.props.isDev !== null && this.props.isDev !== "") {
            this.props.configEvents.setIsDev(this.props.isDev)
        }

        // 이벤트 바인딩
        this.handleSetSetting = this.handleSetSetting.bind(this);
        this.handleSetLanguage= this.handleSetLanguage.bind(this);
        this.getFromAdvisor = this.getFromAdvisor.bind(this);
        this.getFromApp = this.getFromApp.bind(this);
        window.botInit = this.botInit.bind(this);
        this.handleSetGptSetting = this.handleSetGptSetting.bind(this); //20251028 GPT


        this.state = {
            alertMsg : '',
            closeAll : false,
			agreeContentType : "feedback",
			showUseTip: false,
			showExpiresBtn: true,
            gptYn: props.setting.gptMode || "N", // API에서 가져온 값으로 초기화
            inputValue: '',


        }

		const HAS_VISITED_BEFORE = getCookie('hasVisitedBefore');   //기존 sessionStorage 저장하던 것을 cookie에 저장으로 변경

		if (HAS_VISITED_BEFORE != null) {
			this.state = {
				...this.state,
				showUseTip: false,
			};
			//console.info("hideUseTip", this.state)
		} else {
			this.state = {
				...this.state,
				showUseTip: true,
			};
			//console.info("showUseTip", this.state)
		}

        if (!isIframe) {
            this.botInit()
        } else {
            window.addEventListener('message', function(e) {
                if (e.data.botInit === true){
                    window.botInit()
                }
            });
        }

        console.debug("[DEBUG]is iframe : ", isIframe)
    }
    
	pushSet() {
		//console.info(this.props.setting)
		return setTimeout(() => {
			//alert('Push message');
			let sendData = {
                "sessionKey" : this.props.message.sessionKey,
                "channelId" : this.props.message.channelId,
                "isLogin" : this.props.message.isLogin,
                "isDev" : this.props.config.isDev,
                "projectId" : this.props.config.projectId,
            }
			this.props.messageEvents.getPush(sendData);
		}, this.props.setting.pushTimeout * 1000 * 60);
	}

 	timer;
    componentDidUpdate(prevProps, prevState) { //  업데이트 후 실행되는 로직
		if (this.props.setting.pushTimeout !== undefined 
			&& this.props.setting.pushTimeout !== '' 
			&& this.props.setting.pushTimeout > 0) {
			if (prevProps.message.isPushMessage === undefined && this.props.message.isPushMessage === false) { //처음 
				this.timer = this.pushSet();
			} else if (prevProps.message.isPushMessage === false && this.props.message.isPushMessage === false){
				if (this.timer !== undefined) {
					clearTimeout(this.timer);
				}
				this.timer = this.pushSet();
			}  else if (prevProps.setting.gptMode !== this.props.setting.gptMode) { //gpt모드 추가
                this.setState({ gptMode: this.props.setting.gptMode });
                this.setState({ gptYn: this.props.setting.gptMode });

                }

        else {
				if (this.timer !== undefined) {
					clearTimeout(this.timer);
				}
			}
        }

        if (this.props.feedback.alertMessage !== undefined && this.props.feedback.alertMessage !== '') {
            this.openAlert(this.props.feedback.alertMessage)
        }
        // 자동완성 OFF이고 이전에 자동완성 데이터가 있는 경우 초기화 한다.
        if ((prevProps.setting.useArk !== this.props.setting.useArk) 
            && (prevProps.setting.useArk === true && this.props.setting.useArk === false)) {
            this.props.arkEvents.init()
        } 
        // 자동완성 ON이고 질의문 입력창에 질의가 있는 경우 자동완성데이터를 요청한다.
        if ((prevProps.setting.useArk !== this.props.setting.useArk) 
            && (prevProps.setting.useArk === false && this.props.setting.useArk === true)
            && this.props.ark.query) {
            this.props.arkEvents.get({ value : this.props.ark.query, isDev : this.props.isDev })
        } 

        let key = this.props.projectId
        if (key === undefined) key = '13'

        if (prevProps.message !== this.props.message) {
            if (prevProps.message.data.length === 0 && this.props.message.data.length === 1) {
                const _data = JSON.parse(window.sessionStorage.getItem('_data_'+key))
                if (_data !== undefined && _data !== null && _data.data.length > 0 && _data.isLogin === this.props.setting.isLogin) {
                    //this.props.messageEvents.init({initData: _data.data, sessionKey: this.props.message.sessionKey}) 
                } else if (_data !== undefined && _data !== null && _data.isLogin !== this.props.setting.isLogin) {
                    window.sessionStorage.clear();
                }
            }

            if (this.props.message.sessionKey !== null && this.props.message.sessionKey !== "") {
                window.sessionStorage.setItem('_data_'+key, JSON.stringify(this.props.message))
            }
            // 다시 그릴때 실시간을 무조건 보이게 세팅
            this.props.uiEvents.Layout.toggleRealtimeAnswer(true)
        } 

        if (prevProps.setting.favorite !== this.props.setting.favorite) {
            this.handleSetSetting()
        }

        //getSso API결과에 따라 SSO관련 리다이렉트 여부 실행
        //- 04.11 SSO 라이브러리,소스 변경으로 리다이렉트 없이 테스트
        if (prevProps.ssoCheck.needRedirect !== this.props.ssoCheck.needRedirect) {
            redirectSso(this.props.ssoCheck, this.getFromAdvisor())
        }
        //GPT로딩시 
        if (prevProps.message.isLoding === false && this.props.message.isLoding === true) {
                this.setState({ inputValue: '' });
            }    
}

    botInit() {
        this.props.settingEvents.get(this.props);
        this.props.realTimeAnswerEvent.get(this.props);
        this.props.messageEvents.get(this.props);

		this.props.feedbackEvents.getFeedback(this.props);
		this.props.feedbackEvents.getEvent(this.props);

        this.props.ssoEvents.getSsoStatus(this.props);  //SSO 로그인 체크
            // 로그인 되어 있으면 GPT 사용 여부 가져오기
    // if (this.props.message.isLogin) { //20251028 GPT
    //     this.props.GptModeEvents.get({ sessionKey: this.props.message.sessionKey })
    //         .then((res) => {
    //             // res.gptYn 같은 값이 돌아온다고 가정
    //             if(res && res.gptYn !== undefined){
    //                 this.setState({ gptYn: res.gptYn });
    //             }
    //         });
    // }


    }

    openAlert(alertMsg) {
        this.setState({
            alertMsg : alertMsg,
        })
        this.props.uiEvents.Layout.controlOverlay({toggle:true, closeAll:this.state.closeAll})
        if (this.props.feedback.alertMessage !== '') {
            this.setState({
                closeAll : true
            })
            this.props.feedbackEvents.clearAlert()
        } 
    }

    closeAlert() {
        this.setState({
            alertMsg : '',
        })
        this.props.uiEvents.Layout.controlOverlay({toggle:false, closeAll:this.state.closeAll})
        if (this.state.closeAll === true) {
            this.setState({
                closeAll : false
            })
        }
    }

	setExpires() {
		let now = new Date();
		let expires = new Date(now.setMonth(now.getMonth() + 1));
		setCookie('hasVisitedBefore', true, expires);
		this.setState({
			showUseTip: false,
		});
	}

	closeUseTip() {
		this.setState({
			showUseTip: false,
		});
	}

	openUseTip() {
		this.setState({
			showUseTip: true,
			showExpiresBtn: false,
		});
	}

	setAgreeContent(type) {
		this.setState({
            agreeContentType : type,
        })
	}

    handleSetSetting() {
        
        if (this.props.message.isLogin) {
            console.debug("[SetSetting]this.props")
            this.props.settingEvents.set({
                settingData : this.props.setting, gptYn: this.state.gptYn , isDev : this.props.config.isDev, projectId : this.props.config.projectId });
        }
    }
    

        handleSetLanguage(lang) {
        console.debug("[handleSetLanguage]",lang)
        this.props.configEvents.setLang(lang)
        switch(lang) {
            case 'ko': 
                this.props.configEvents.setProject('13')
                break
            case 'en':
                this.props.configEvents.setProject('14')
                break
            case 'cn':
                this.props.configEvents.setProject('15') 
                break
            case 'ja':
                this.props.configEvents.setProject('20') 
                break
            case 'vi':
                this.props.configEvents.setProject('21') 
                break
            default:
        }
        this.props.settingEvents.get(this.props);
        this.props.realTimeAnswerEvent.get(this.props);
        this.props.messageEvents.get(this.props);
    }

    getFromApp() {
        return this.props.config.from === "eadvisorapp" ? true : false;
    }

    getFromAdvisor() {
        return this.props.config.from === "eadvisor" || this.props.config.from === "eadvisorapp" ? true : false;
    }
    
handleSetGptSetting(value) {
    this.setState({ gptYn: value  , projectId : this.props.config.projectId});
    if (this.props.message.isLogin) {  // 20251028 GPT 실제 운영 반영때는 풀어야함.
        this.props.GptModeEvents.setGpt({ gptYn: value , projectId : this.props.config.projectId, isLogin : this.props.message.isLogin});
    }
}
handleChangeInput = (value) => {
    this.setState({ inputValue: value });
};

    render(){
        let mainClass = "chat_wrap"
        if (this.props.config.from === "eadvisor" || this.props.config.from === "eadvisorapp") {
            mainClass = "advisor_wrap"
        }
        const theme = this.props.setting.theme
        const fromAdvisor = this.getFromAdvisor()
        const fromApp = this.getFromApp()
        return (
			<React.Fragment>
			{/* { this.state.showUseTip && !fromAdvisor && (
				<UseTip closeUseTip={() => this.closeUseTip()} setExpires={() => this.setExpires()} showExpiresBtn={this.state.showExpiresBtn} />
				
			)} */}
            <div className={theme}>
            <div className={mainClass}>
                <ChatTop
                    setLang={this.handleSetLanguage}
                    lang={this.props.config.language}
                    openSideMenu={this.props.uiEvents.Layout.openSideMenu}
                    openFeedback={this.props.uiEvents.Layout.openFeedback}
                    loginAlert={this.props.uiEvents.Layout.openLoginAlert}
                    controlOverlay={this.props.uiEvents.Layout.controlOverlay}
                    isLogin={this.props.message.isLogin}
                    init={this.props.message.init}
                    menuPosition={this.props.setting.menuPosition}
                    fromAdvisor={fromAdvisor}
                    fromApp={fromApp}
                    toggleRealtimeAnswer={this.props.uiEvents.Layout.toggleRealtimeAnswer}
                    uiTexts={this.props.ui.texts}
                    gptMode= {this.state.gptYn} //20251031
                    />
                <ChatMessageList 
                    data={this.props.message}
                    isDev={this.props.config.isDev}
                    favorite={this.props.setting.favorite}
                    fromApp={fromApp}
                    toggleRealtimeAnswer={this.props.uiEvents.Layout.toggleRealtimeAnswer}
                    uiTexts={this.props.ui.texts}
                    ref={(ref) => {this.ChatMessageList = ref;}}/>
                <ChatBottom
                    value={this.state.inputValue}
                    onChangeValue={this.handleChangeInput}
                    config={this.props.config}
                    fromAdvisor={fromAdvisor}
                    fromApp={fromApp}
                    realtimeAnswer={this.props.realtimeAnswer}
                    getArk={this.props.arkEvents.get}
                    useArk={this.props.setting.useArk}
                    settingArk={this.props.settingEvents.useArk}
                    arkData={this.props.ark.data}
                    showFavorites={this.props.ui.showFavorites}
                    showRealtimeAnswer={this.props.ui.showRealtimeAnswer}
                    toggleFavorites={this.props.uiEvents.Layout.toggleFavorites}
                    toggleRealtimeAnswer={this.props.uiEvents.Layout.toggleRealtimeAnswer}
                    setFavorite={this.props.settingEvents.setFavorite}
                    favorite={this.props.setting.favorite}
                    sessionKey={this.props.message.sessionKey}
                    channelId={this.props.message.channelId}
                    responseType={this.props.message.responseType}
                    blockId={this.props.message.dialogTaskId}
                    isLogin={this.props.message.isLogin}
                    clearTextbox={this.props.message.clearTextbox}
                    send={this.props.messageEvents.send}
                    uiTexts={this.props.ui.texts}
                    ref={(ref) => {this.ChatBottom = ref}}
                    />
            </div>
            {this.props.ui.overLayShow &&
            <OverLayLayer
                click={this.props.uiEvents.Layout.clickOverlay}
                isLoginAlert={this.props.ui.clickLoginAlert}
                isViewAgree={this.props.ui.clickAgreeContent}
                zIndex={this.props.ui.overLayzIndex}/>
            }
            {this.props.ui.clickSideMenu &&
            <SideMenuLayer 
                close={this.props.uiEvents.Layout.closeSideMenu}
                openSetting={this.props.uiEvents.Layout.openSetting}
                loginAlert={this.props.uiEvents.Layout.openLoginAlert}
                send={this.props.messageEvents.send}
                sessionKey={this.props.message.sessionKey}
                channelId={this.props.message.channelId}
                isLogin={this.props.message.isLogin}
                isLoding={this.props.message.isLoding}
                userName={this.props.message.userName}
                menuPosition={this.props.setting.menuPosition}
                theme={this.props.setting.theme}
                setMenuPostion={this.props.settingEvents.menuPosition}
                setTheme={this.props.settingEvents.setTheme}
                setSetting={this.handleSetSetting}
                uiTexts={this.props.ui.texts}
                lang={this.props.config.language}
                // gptYn={this.state.gptYn}              // gpt 정보 추가 251028
                // setGptYn={this.props.GptModeEvents.setGpt} // gpt 정보 추가 251028
                setGptYn={this.handleSetGptSetting} // gpt 정보 추가 251028
            
                //  gptMode= {this.props.setting.gptMode} 
                gptMode= {this.state.gptYn} //20251031

//   setGptYn={this.props.GptModeEvents.setGpt}     // ✅ store 갱신 (dispatch)

                />
            }

            {this.props.ui.clickSetting &&
            <SettingLayer
                close={this.props.uiEvents.Layout.closeSetting}
                alert={(payload) => this.openAlert(payload)}
                useArk={this.props.settingEvents.useArk}
                menuPosition={this.props.settingEvents.menuPosition}
                toggleGreeting={this.props.settingEvents.toggleGreeting}
                toggleQuickMenu={this.props.settingEvents.toggleQuickMenu}
                data={this.props.setting}
                setSetting={this.handleSetSetting}
                uiTexts={this.props.ui.texts}
                gptMode= {this.props.setting.gptMode} //20251031

                
                />
            }
            { this.props.ui.clickFeedback &&
            <FeedbackLayer
                config={this.props.config}
                view={this.props.uiEvents.Layout.openAgreeContent}
                close={this.props.uiEvents.Layout.closeFeedback}
                alert={(payload) => this.openAlert(payload)} // 안에서 밖으로 보내는 에러 메세지
				setAgreeContent={(payload) => this.setAgreeContent(payload)}
                writeFeedback={this.props.feedbackEvents.writeFeedback}
				writeEvent={this.props.feedbackEvents.writeEvent}
				data={this.props.feedback}
                uiTexts={this.props.ui.texts}
                />
            }
            { this.props.ui.clickAgreeContent &&
            <AgreeContentLayer
				type={this.state.agreeContentType}
				data={this.props.feedback}
                close={this.props.uiEvents.Layout.closeAgreeContent}/>
            }
            {this.props.ui.clickLoginAlert &&
            <LoginAlertLayer
                clickOverlay={this.props.uiEvents.Layout.clickOverlay}
                close={this.props.uiEvents.Layout.closeLoginAlert}
                clickSideMenu={this.props.ui.clickSideMenu}
                uiTexts={this.props.ui.texts}
                fromApp={fromApp}
                />
            }
            {this.props.ui.showFavoriteAlert &&
            <AlertFavorites 
                action={this.props.ui.favoriteAction}
                utterance={this.props.ui.tempUtterance}
                favorites={this.props.setting.favorite}
                setFavorite={this.props.settingEvents.setFavorite}
                clickOverlay={this.props.uiEvents.Layout.clickOverlay}
                close={this.props.uiEvents.Layout.closeFavoriteAlert} 
                setSetting={this.handleSetSetting}
                uiTexts={this.props.ui.texts}
                />
            }
            {this.state.alertMsg !== '' &&
            <AlertLayer
                close={()=>this.closeAlert()}
                message={this.state.alertMsg}
                uiTexts={this.props.ui.texts}/>
            }
            </div>
			</React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        ui: state.ui,
        message: state.message,
        ark: state.ark,
        setting: state.setting,
        feedback: state.feedback,
        realtimeAnswer: state.realtimeAnswer,
        config: state.config
        ,ssoCheck: state.ssoCheck
    };
}

function mapDispatchToProps(dispatch) {
    
    return {
        configEvents:{
            setProject:(payload)=> dispatch(configAction.setProject(payload)),
            setFrom:(payload)=> dispatch(configAction.setFrom(payload)),
            setLang:(payload)=> dispatch(configAction.setLang(payload)),
            setIsDev:(payload)=> dispatch(configAction.setIsDev(payload)),
        },
        realTimeAnswerEvent: {
            get:(payload)=> dispatch(realtimeAction.getRealtimeAnswer(payload)),
        },
        messageEvents: {
            get:(payload) => dispatch(messageActions.getGreeting(payload)),
            send:(payload) => dispatch(messageActions.sendMessage(payload)),
            init:(payload) => dispatch(messageActions.initMessage(payload)),
			getPush:(payload) => dispatch(messageActions.pushMessage(payload)),
        },
        uiEvents: {
            Layout: {
                openSideMenu: () => dispatch(uiActions.openSideMenu()),
                closeSideMenu: () => dispatch(uiActions.closeSideMenu()),
                openSetting: () => dispatch(uiActions.openSetting()),
                closeSetting: () => dispatch(uiActions.closeSetting()),
                openFeedback: () => dispatch(uiActions.openFeedback()),
                closeFeedback: () => dispatch(uiActions.closeFeedback()),
                openAgreeContent: () => dispatch(uiActions.openAgreeContent()),
                closeAgreeContent: () => dispatch(uiActions.closeAgreeContent()),
                openLoginAlert: () => dispatch(uiActions.openLoginAlert()),
                closeLoginAlert: () => dispatch(uiActions.closeLoginAlert()),
                clickOverlay: () => dispatch(uiActions.clickOverlay()),
                controlOverlay: (payload) => dispatch(uiActions.controlOverlay(payload)),
                toggleFavorites: () => dispatch(uiActions.toggleFavorites()),
                closeFavoriteAlert:() => dispatch(uiActions.closeFavoriteAlert()),
                setTexts: (payload) => dispatch(uiActions.setTexts(payload)),
                toggleRealtimeAnswer: (payload) => dispatch(uiActions.showRealtimeAnswer(payload)),
				toggleUseTip: (payload) => dispatch(uiActions.toggleUseTip(payload)),
            }
        },
        arkEvents: {
            get: (payload) => dispatch(arkActions.getArk(payload)), 
            init: () => dispatch(arkActions.initArk()),
        },
        settingEvents: {
            get: (payload) => dispatch(settingAction.getSetting(payload)),
            set: (payload) => dispatch(settingAction.setSetting(payload)),
            useArk: (payload) => dispatch(settingAction.useArk(payload)),
            menuPosition: (payload) => dispatch(settingAction.menuPosition(payload)),
            toggleGreeting: (payload) => dispatch(settingAction.toggleGreeting(payload)),
            setFavorite: (payload) => dispatch(settingAction.setFavorite(payload)),
            setTheme: (payload) => dispatch(settingAction.setTheme(payload)),
        },
        feedbackEvents: {
			getEvent: (payload) =>dispatch(feedbackAction.getEvent(payload)),
			writeEvent: (payload) =>dispatch(feedbackAction.writeEvent(payload)),
			getFeedback: (payload) =>dispatch(feedbackAction.getFeedback(payload)),
            writeFeedback: (payload) =>dispatch(feedbackAction.writeFeedback(payload)),
            clearAlert:() => dispatch(feedbackAction.clearFeedbackAlert())
        }
        ,ssoEvents: {    //SSO 인증 상태 정보 조회
			getSsoStatus: (payload) =>dispatch(ssocheckAction.getSsoStatus(payload)),
        } 
        ,GptModeEvents: {    //Gpt Mode 
            get: (payload) => dispatch(settingAction.getSetting(payload)),
            setGpt: (payload) => dispatch(settingAction.setGpt(payload))
        }
    };
}

export default addUrlProps({ urlPropsQueryConfig}) (connect(mapStateToProps, mapDispatchToProps)(App));